export const faceSwapeStyleOptions = {
    style: {
      shotType: {
        label: 'Shot Type',
        options: {
          portrait: 'Portrait',
          headPortrait: 'Head Portrait',
          headAndShoulders: 'Head and Shoulders Portrait',
          halfLength: 'Half-length Portrait',
          fullLength: 'Full-length Portrait',
          face: 'Face',
          closeUp: 'Close-up'
        }
      },
      imagingStyle: {
        label: 'Imaging Style',
        options: {
          standard: 'Standard Mode',
          highContrast: 'High Contrast Mode',
          landscape: 'Landscape Mode',
          portrait: 'Portrait Mode',
          blackAndWhite: 'Black and White Mode',
          clarityEnhancement: 'Clarity Enhancement'
        }
      },
      artisticStyle: {
        label: 'Artistic Style',
        options: {
          realistic: 'Realistic Style',
          illustration: 'Illustration Style',
          cartoon: 'Cartoon Style',
          watercolor: 'Watercolor Style',
          vintage: 'Vintage Style',
          steampunk: 'Steampunk Style'
        }
      },
      artEffect: {
        label: 'Art Effect',
        options: {
          oilPainting: 'Oil Painting Effect',
          inkWash: 'Ink Wash Painting Effect',
          sketch: 'Sketch Effect',
          coloredPencil: 'Colored Pencil Effect'
        }
      },
      depthOfField: {
        label: 'Depth of Field',
        options: {
          shallow: 'Shallow Depth of Field',
          medium: 'Medium Depth of Field',
          deep: 'Deep Depth of Field'
        }
      },
      photoEffect: {
        label: 'Photo Effect',
        options: {
          aspectRatioCrop: 'Aspect Ratio Crop (1:1, 16:9)',
          vintage: 'Vintage Style',
          hdr: 'HDR (High Dynamic Range)',
          filmEffect: 'Film Effect',
          hardSoftLight: 'Hard and Soft Light',
          longExposure: 'Long Exposure Effect'
        }
      },
      specialEffect: {
        label: 'Special Effect',
        options: {
          lowSaturation: 'Low Saturation',
          highContrast: 'High Contrast',
          hdr: 'High Dynamic Range (HDR)',
          duotone: 'Duotone Effect',
          fluorescent: 'Fluorescent/Neon Style'
        }
      },
      postProcessingStyle: {
        label: 'Post Processing Style',
        options: {
          filter: 'Filter (vintage, B&W, film)',
          sharpening: 'Sharpening',
          denoise: 'Denoise',
          colorCorrection: 'Color Correction',
          filmGrain: 'Film Grain'
        }
      }
    }
  };
